import classnames from 'classnames';
import React from 'react';
import styles from './styles.scss';

interface Props {
  tg1Count: number;
  tg2Count: number;
  tg3Count: number;
  className?: string;
}

const PropertyStatusBar = ({ tg1Count, tg2Count, tg3Count, className }: Props): JSX.Element => {
  const isObos = typeof document !== 'undefined' && document.referrer && /.*obos\.no/.test(document.referrer);
  return (
    <ul className={classnames(styles.bar, className && className)}>
      <li
        className={classnames(styles.tg, styles.tg1, isObos ? styles.tg1_obos : null, className && className)}
        style={{ flexGrow: tg1Count }}
      >
        {tg1Count}
      </li>
      <li
        className={classnames(styles.tg, styles.tg2, isObos ? styles.tg2_obos : null, className && className)}
        style={{ flexGrow: tg2Count }}
      >
        {tg2Count || null}
      </li>
      <li
        className={classnames(styles.tg, styles.tg3, isObos ? styles.tg3_obos : null, className && className)}
        style={{ flexGrow: tg3Count }}
      >
        {tg3Count || null}
      </li>
    </ul>
  );
};

PropertyStatusBar.defaultProps = {
  tg1Count: 0,
  tg2Count: 0,
  tg3Count: 0,
};

export default PropertyStatusBar;
